const AUTH_TYPES = [
  "api_key",
  "bedrock_api_token",
  "bedrock_aws_credentials",
  "ollama"
];
const isProviderAuth = (value) => {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  return AUTH_TYPES.includes(value.type);
};
export const toProviderAuth = (value) => isProviderAuth(value) ? value : void 0;
const isEncryptedValue = (value) => typeof value === "object" && value !== null && "is_set" in value;
export const toFormAuth = (auth) => Object.fromEntries(
  Object.entries(auth).map(
    ([key, value]) => isEncryptedValue(value) && value.is_set ? [key, { keep_value: true }] : [key, value]
  )
);
export const emptyAuthFor = (provider, region) => {
  switch (provider) {
    case "bedrock":
      return { type: "bedrock_api_token", region };
    case "ollama":
      return { type: "ollama" };
    default:
      return { type: "api_key" };
  }
};
